export const ENQUEUE_PUBLISH_JOB = 'ENQUEUE_PUBLISH_JOB';
export const UPDATE_PUBLISH_JOB_PROGRESS = 'UPDATE_PUBLISH_JOB_PROGRESS';
export const REMOVE_PUBLISH_JOB = 'REMOVE_PUBLISH_JOB';
export const MARK_BANNER_LIST_STALE = 'MARK_BANNER_LIST_STALE';
export const CLEAR_BANNER_LIST_STALE = 'CLEAR_BANNER_LIST_STALE';
export const MARK_TEMPLATE_LIST_STALE = 'MARK_TEMPLATE_LIST_STALE';
export const CLEAR_TEMPLATE_LIST_STALE = 'CLEAR_TEMPLATE_LIST_STALE';
export const MARK_PARTNERS_LIST_STALE = 'MARK_PARTNERS_LIST_STALE';
export const CLEAR_PARTNERS_LIST_STALE = 'CLEAR_PARTNERS_LIST_STALE';
export const MARK_BRANDS_LIST_STALE = 'MARK_BRANDS_LIST_STALE';
export const CLEAR_BRANDS_LIST_STALE = 'CLEAR_BRANDS_LIST_STALE';
export const MARK_DEPARTMENTS_LIST_STALE = 'MARK_DEPARTMENTS_LIST_STALE';
export const CLEAR_DEPARTMENTS_LIST_STALE = 'CLEAR_DEPARTMENTS_LIST_STALE';
export const MARK_PAGES_LIST_STALE = 'MARK_PAGES_LIST_STALE';
export const CLEAR_PAGES_LIST_STALE = 'CLEAR_PAGES_LIST_STALE';
export const MARK_CAREERS_LIST_STALE = 'MARK_CAREERS_LIST_STALE';
export const CLEAR_CAREERS_LIST_STALE = 'CLEAR_CAREERS_LIST_STALE';
export const MARK_CAREER_APPLICATIONS_LIST_STALE = 'MARK_CAREER_APPLICATIONS_LIST_STALE';
export const CLEAR_CAREER_APPLICATIONS_LIST_STALE = 'CLEAR_CAREER_APPLICATIONS_LIST_STALE';
export const MARK_OUR_TEAM_LIST_STALE = 'MARK_OUR_TEAM_LIST_STALE';
export const CLEAR_OUR_TEAM_LIST_STALE = 'CLEAR_OUR_TEAM_LIST_STALE';
export const MARK_PROJECTS_LIST_STALE = 'MARK_PROJECTS_LIST_STALE';
export const CLEAR_PROJECTS_LIST_STALE = 'CLEAR_PROJECTS_LIST_STALE';
export const MARK_CATEGORIES_LIST_STALE = 'MARK_CATEGORIES_LIST_STALE';
export const CLEAR_CATEGORIES_LIST_STALE = 'CLEAR_CATEGORIES_LIST_STALE';
export const MARK_WIDGETS_LIST_STALE = 'MARK_WIDGETS_LIST_STALE';
export const CLEAR_WIDGETS_LIST_STALE = 'CLEAR_WIDGETS_LIST_STALE';
export const MARK_SEO_LIST_STALE = 'MARK_SEO_LIST_STALE';
export const CLEAR_SEO_LIST_STALE = 'CLEAR_SEO_LIST_STALE';
export const MARK_INFORMATION_POLICY_LIST_STALE = 'MARK_INFORMATION_POLICY_LIST_STALE';
export const CLEAR_INFORMATION_POLICY_LIST_STALE = 'CLEAR_INFORMATION_POLICY_LIST_STALE';
export const MARK_ADMIN_SETTINGS_STALE = 'MARK_ADMIN_SETTINGS_STALE';
export const CLEAR_ADMIN_SETTINGS_STALE = 'CLEAR_ADMIN_SETTINGS_STALE';
export const MARK_CONFIG_SETTINGS_STALE = 'MARK_CONFIG_SETTINGS_STALE';
export const CLEAR_CONFIG_SETTINGS_STALE = 'CLEAR_CONFIG_SETTINGS_STALE';
